import { TUnitSettingStore } from '@/stores';

import { DefaultOptionType } from 'antd/es/select';

export interface IInner {}

export interface IOutter {}

export type DataType = {
	id: number;
	type: string;
	typeDetail: string;
	districtId: number;
	employerName: string;
	address: string;
	employerBirthDate: string;
	employerPhone: string;
	email: string;
	workplace?: string;
	phone: string;
	productionType: number;
	productionTypeDetail: string;
	productionScale: string;
	productionUnit: number;
	businessRegistNo: string;
	corporateRegistNo: string;
	employmentType: number;
	isPublic: number;
	publicFranchiseId: number;
	requestApplicant: number;
	assignmentApplicant: number;
	additionalAssignmentApplicant: number;
	additionalPeople?: number;
	isLack: number;
	hasLodging: number;
	memo: number;
	registDt: string;
	updateDt: string;
};

export type IProps = IInner & IOutter;

export enum ESearchType {
	ID = 'ID',
	DISTRICT_ID = 'DISTRICT_ID',
	EMAIL = 'EMAIL',
	NAME = 'NAME',
	PHONE = 'PHONE',
	TYPE = 'TYPE',
	TYPE_DETAIL = 'TYPE_DETAIL',
	PRODUCTION_TYPE = 'PRODUCTION_TYPE',
	PRODUCTION_TYPE_DETAIL = 'PRODUCTION_TYPE_DETAIL',
	PRODUCTION_UNIT = 'PRODUCTION_UNIT',
	PRODUCTION_SCALE = 'PRODUCTION_SCALE',
	MAX_MANPOWER_ALLOWED = 'MAX_MANPOWER_ALLOWED',
	ADDRESS = 'ADDRESS',
	EMPLOYER_NAME = 'EMPLOYER_NAME',
	EMPLOYER_BIRTH_DATE = 'EMPLOYER_BIRTH_DATE',
	EMPLOYER_PHONE = 'EMPLOYER_PHONE',
	PENALTY_POINTS_ACCUMULATED = 'PENALTY_POINTS_ACCUMULATED',
	IS_ALLOCATION_RESTRICTED = 'IS_ALLOCATION_RESTRICTED',
	IS_PUBLIC = 'IS_PUBLIC',
	PUBLIC_FRANCHISE_ID = 'PUBLIC_FRANCHISE_ID',
	BUSINESS_REGIST_NO = 'BUSINESS_REGIST_NO',
	CORPORATE_REGIST_NO = 'CORPORATE_REGIST_NO',
	MEMO = 'MEMO',
	WORK_START_TIME = 'WORK_START_TIME',
	WORK_END_TIME = 'WORK_END_TIME',
	MONTHLY_WORKING_HOURS = 'MONTHLY_WORKING_HOURS',
	DAILY_BREAKS_NUMBER = 'DAILY_BREAKS_NUMBER',
	DAILY_BREAKS_HOUR = 'DAILY_BREAKS_HOUR',
	DAILY_BREAKS_MIN = 'DAILY_BREAKS_MIN',
	REQUEST_APPLICANT = 'REQUEST_APPLICANT',
	ASSIGNMENT_FRANCHISE_REQUEST_APPLICANT = 'ASSIGNMENT_FRANCHISE_REQUEST_APPLICANT',
	ASSIGNMENT_APPLICANT = 'ASSIGNMENT_APPLICANT',
	ADDITIONAL_ASSIGNMENT_APPLICANT = 'ADDITIONAL_ASSIGNMENT_APPLICANT',
	IS_LACK = 'IS_LACK',
	HAS_LODGING = 'HAS_LODGING',
	GRADE_A_DAILY_WAGE = 'GRADE_A_DAILY_WAGE',
	GRADE_B_DAILY_WAGE = 'GRADE_B_DAILY_WAGE',
	GRADE_C_DAILY_WAGE = 'GRADE_C_DAILY_WAGE',
	DEFAULT_GRADE = 'DEFAULT_GRADE',
	REGIST_ID = 'REGIST_ID',
	REGIST_NAME = 'REGIST_NAME',
	REGIST_DT = 'REGIST_DT',
	UPDATE_DT = 'UPDATE_DT',
	CUSTOM_FIELD_1 = 'CUSTOM_FIELD_1',
	CUSTOM_FIELD_2 = 'CUSTOM_FIELD_2',
	CUSTOM_FIELD_3 = 'CUSTOM_FIELD_3',
	CUSTOM_FIELD_4 = 'CUSTOM_FIELD_4',
	CUSTOM_FIELD_5 = 'CUSTOM_FIELD_5',
	IS_WITHDRAWN = 'IS_WITHDRAWN',
	AGREEMENT_DT = 'AGREEMENT_DT',
}

export type TFilterProps = Partial<{
	districtList?: DefaultOptionType[];
	publicFranchiseList?: DefaultOptionType[];
	optionalFieldFranchiseList?: TUnitSettingStore['optionalFieldFranchiseList'];
	isWorkerPublicAdminRole?: boolean;
	isFilterEmployerName?: boolean;
	adminDistrictId?: number;
}>;
